/**
 * RFC-150: Landing stat strip — sourced numbers only.
 * Every entry MUST carry a non-null `source`. The source strings render as a
 * single visible footnote line under the stat strip (mobile + desktop, SR
 * friendly), enforced by the marketing-cohesion contract test.
 */
export interface LandingStat {
  /** Big display value, e.g. "★ 5.0" or "8". */
  value: string;
  /** Short label under the value, e.g. "App Store rating". */
  label: string;
  /** Where this number comes from. Surfaces as a footnote. Non-null. */
  source: string;
}

export const LANDING_STATS: readonly LandingStat[] = [
  { value: '★ 5.0',  label: 'App Store rating',     source: 'App Store & Google Play, May 2026' },
  { value: '8',      label: 'Languages supported',  source: 'iOS + Android + Web' },
  { value: 'FSRS-6', label: 'Same algorithm as Anki', source: 'open-spaced-repetition.github.io' },
] as const;
